import { render, staticRenderFns } from "./warehouseLogistics.vue?vue&type=template&id=38f6f480"
import script from "./warehouseLogistics.vue?vue&type=script&lang=js"
export * from "./warehouseLogistics.vue?vue&type=script&lang=js"
import style0 from "./warehouseLogistics.vue?vue&type=style&index=0&id=38f6f480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports